<template>
  <v-row no-gutters>
    <v-col cols="4">
      <v-row>
        <v-col>
          <span key="0"> Soil Profile {{ index + 1 }} </span>
        </v-col>
      </v-row>
    </v-col>
    <template v-if="!open">
      <v-fade-transition leave-absolute>
        <v-col cols="8" class="text--secondary">
          <v-row>
            <v-divider vertical></v-divider>
            <v-col cols="4" class="center">
              <v-row class="pl-2 center">
                <v-col>
                  <small>X</small>
                </v-col>
                <v-col>
                  <small>{{ itemProfile.x }}m </small></v-col
                >
              </v-row>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="4" class="center">
              <v-row class="pl-2 center">
                <v-col>
                  <small>Start</small>
                </v-col>
                <v-col>
                  <small
                ><span v-if="index === 0">Left</span>
                <span v-else>{{ itemProfile.x_start }}m </span></small
              ></v-col
                >
              </v-row>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="4" class="center">
              <v-row class="pl-2 center">
                <v-col>
                  <small>End</small>
                </v-col>
                <v-col>
                  <small
                ><span v-if="index === endIndex">Right</span>
                <span v-else>{{ itemProfile.x_end }}m</span></small
              ></v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-fade-transition>
    </template>
  </v-row>
</template>
<script>
export default {
  name: "SoilProfileBlockHeader",
  props: {
    index: {},
    endIndex: {},
    itemProfile: {},
    open: {},
  },
};
</script>
